/**
 * Static reference content for the Emergency Category & Preparedness form.
 * These lists are printed instructions, not captured answers, so they live in
 * the frontend only.
 */

export const EMERGENCY_PROTOCOL_NOTICE = {
  title: "Protocol for life-threatening emergencies",
  body: "In the event a life-threatening scenario arises, immediately contact emergency services by dialing 911. Make sure dispatchers have access to the patient's address, medical history, and current prescriptions.",
};

export const CALL_911_ITEMS = [
  "Abrupt loss of consciousness or altered mental acuity.",
  "Grave dyspnea or breathing difficulties.",
  "Severe bodily harm or heavy, uncontrollable bleeding.",
  "Indications of a stroke, sudden chest pain, or pain radiating to the arms or jaw.",
  "Seizures in a patient with no previous history of seizure activity.",
  "Uncontrolled bleeding that cannot be stopped with direct pressure.",
];

export const REPORT_TO_CLINICIAN_ITEMS = [
  "Developing or increasing nausea and vomiting.",
  "Feeling dizzy, weak, or having unexplained fainting spells.",
  "Fever higher than 101°F lasting more than a full day.",
  "Continuous pain that does not improve with prescribed medicine.",
  "New or worsening shortness of breath at rest or with minimal activity.",
  "Sudden increase in swelling or redness in the legs or feet.",
];

/** Checklist items — `key` matches the boolean column on the backend. */
export const PREPAREDNESS_KIT_ITEMS = [
  {
    key: "kitBatteryRadio",
    label: "Battery-powered radio for emergency broadcasts",
  },
  {
    key: "kitThreeDayFood",
    label: "Three-day supply of non-perishable food",
  },
  {
    key: "kitBatteriesFlashlight",
    label: "Extra batteries and a flashlight",
  },
  {
    key: "kitThreeDayWater",
    label: "Three-day supply of drinking water (one gallon per person, per day)",
  },
  {
    key: "kitFirstAidSupplies",
    label: "First aid kit and first aid manual",
  },
  {
    key: "kitMedicationRecords",
    label: "Copy of the medication list and key medical records",
  },
];

export const TRIAGE_CATEGORIES = [
  {
    value: "category_i",
    title: "Category I: Needs immediate care",
    description:
      "Dependent on life-sustaining equipment or medically unstable. Must be contacted and seen first during any disruption of service.",
    tone: {
      title: "text-red-600",
      selected: "border-red-300 bg-red-50/60 ring-1 ring-red-200",
      dot: "border-red-400 text-red-600",
    },
  },
  {
    value: "category_ii",
    title: "Category II: Moderate importance",
    description:
      "Requires assistance with care but is medically stable. Should be seen within 48 hours; a caregiver can provide interim support.",
    tone: {
      title: "text-amber-600",
      selected: "border-amber-300 bg-amber-50/60 ring-1 ring-amber-200",
      dot: "border-amber-400 text-amber-600",
    },
  },
  {
    value: "category_iii",
    title: "Category III: Low priority",
    description:
      "Independent or fully supported by a caregiver. Visits may be rescheduled until normal services resume.",
    tone: {
      title: "text-emerald-600",
      selected: "border-emerald-300 bg-emerald-50/60 ring-1 ring-emerald-200",
      dot: "border-emerald-400 text-emerald-600",
    },
  },
];
